const API_BASE =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "development" ? "http://localhost:4000" : "");

async function readJson(response) {
  try {
    return await response.json();
  } catch {
    return {};
  }
}

export async function fetchDemoOptions() {
  const response = await fetch(`${API_BASE}/api/demo-options`);
  const data = await readJson(response);
  if (!response.ok) {
    throw new Error(data.error || "Could not load the form.");
  }
  return data.products;
}

export async function submitDemoRequest(payload) {
  const response = await fetch(`${API_BASE}/api/demo-requests`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await readJson(response);
  if (!response.ok) {
    const error = new Error(data.error || "We could not save your request.");
    error.fields = data.fields;
    throw error;
  }
  return data;
}
